import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConfigEnviroment} from 'src/app/intranet/login/model';


@Injectable()
export class AppConfigService {

  private appConfig: ConfigEnviroment = new ConfigEnviroment();

  constructor(private http: HttpClient) {}

  async loadAppConfig() {
      const rawResponse = await fetch('assets/configs/config.json', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      const content = await rawResponse.json();
      this.appConfig.apiEndpoint = content['apiEndpoint'];
      this.appConfig.apiEndpointClient = content['apiEndpointClient'];
      this.appConfig.envName = content['envName'];
      this.appConfig.production = content['production'];
      this.appConfig.titulo = content['titulo'];
      this.appConfig.value = content['value'];
      return this.appConfig;
  }

  getConfig() {
    this.loadAppConfig().then(cfg => {
      this.appConfig = cfg;
    });
    return this.appConfig;
  }

}
